<div
  [class.disable]="!isActual"
  [class.horizontalMode]="!verticalMode"
  *ngIf="Service.arProfile?.batterylevel && Service.isAuth"
  class="battery no-invert"
>
  <div
    placement="left"
    tooltip="{{ Service.arProfile?.batterylevel + '% ' + (Service.arProfile?.batteryLive ? 'Заряжается' : '') }}"
    class="battery-level"
    [style.height.%]="Service.arProfile?.batterylevel"
  >
    <i-feather *ngIf="Service.arProfile?.batteryLive" name="zap"></i-feather>
  </div>
  <ng-template [ngIf]="!Service.arProfile?.batteryLive">
    <span class="percentBattery" *ngIf="showPercent">{{ Service.arProfile?.batterylevel }}</span>
  </ng-template>
</div>
